<style scoped>
  .calendar-bg{background-image:url("/img/home/calendarBackground.png");background-size:auto 100%;width: 380px;height: 344px;text-align: center;}
  .transparent{width: 356px;height: 220px;background-color: rgba(255,255,255,0.4);display: inline-block;margin-top: 12px;margin-bottom: 37px;}
  .time{font-size: 14px;color: #464c5b;text-align: left;margin:40px 0 10px 40px;line-height: 24px;font-weight: bolder;}
  .should{width: 40px;height: 40px;border-radius: 20px;text-align: center;font-size: 24px;color: #ffffff;background-color: #00a2e9;display: inline-block;line-height: 40px;vertical-align: top;margin: 40px 10px 0 10px;}
</style>
<template>
  <div class="calendar">
    <div class="calendar-bg">
      <div class="transparent">
        <div class="time">
          <div class="">农历{{lunarCalendar.year}}{{lunarCalendar.month}}月{{lunarCalendar.day}} {{weekMap[newCalendar.week]}}</div>
          <div class="">{{newCalendar.year}}年{{newCalendar.month}}月</div>
        </div>
        <div style="text-align: left;">
          <span style="font-size: 72px;color: #464c5b;font-weight: bolder;margin-left: 40px;">{{newCalendar.day<10?'0'+newCalendar.day:newCalendar.day}}</span>
          <div class="should">
            <span>宜</span>
          </div>
          <div style="color: #464c5b;font-size: 24px;vertical-align: top;display: inline-block;margin-top: 42px;">
            御风而行
          <!--{{suit}}-->
          </div>
        </div>
      </div>
      <!--诗-->
      <div style="font-size: 14px;color: #657180;width: 348px;text-align: right;">
        “我们埋在土里的愿望，谁能把它像流水一样遗忘。” ——野孩子《长出来》
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "calendar",
    data:function(){
      return {
        lunarCalendar:{
          year:'',
          month:'',
          day:'',
        },
        newCalendar:{
          year:'3',
          month:'2',
          day:'1',
        },
        suit:"",
        weekMap:{
          Monday:'星期一',
          Tuesday:'星期二',
          Wednesday:'星期三',
          Thursday:'星期四',
          Friday:'星期五',
          Saturday :'星期六',
          Sunday:'星期天',
        },
      }
    },
    methods:{
      getClendar:function () {
        var _this = this
        _this.send({
          headers:'N/CalendarInfo',
          success:function (res) {
            var date = res.date.split("-")
            _this.lunarCalendar.year = res.lunarYear
            _this.lunarCalendar.month = res.lunar
            _this.lunarCalendar.day = res.cnday
            _this.newCalendar.year = date[0]
            _this.newCalendar.month = date[1]
            _this.newCalendar.day = date[2]
            _this.suit = res.suit
            _this.newCalendar.week = res.weekday
          }
        })
      }
    },
    mounted:function () {
      this.getClendar()
    }
  }
</script>
